import { render, staticRenderFns } from "./ElementCriteriaTableColumn.vue?vue&type=template&id=0f19a477&scoped=true"
import script from "./ElementCriteriaTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementCriteriaTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementCriteriaTableColumn.vue?vue&type=style&index=0&id=0f19a477&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19a477",
  null
  
)

export default component.exports